// extracted by mini-css-extract-plugin
module.exports = {"root":"GadsDropdown-module__root__16voA","dropdown-width":"GadsDropdown-module__dropdown-width__1ob88"};